module.exports = __webpack_public_path__ + "img/2022_10_dandelion_nijojo_fin_web.0f4c530f.png";